module.exports = __webpack_public_path__ + "static/media/skid-steer.838f8758.jpg";